import { AuthState } from 'src/app/auth/auth.states';
import { Component, OnChanges, OnDestroy } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EventBusService } from '../services/eventbus';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { EasyTramPlan, Field, Scenario, cloneScenario } from '../fields/field.model';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { ZipArchive } from "@shortercode/webzip";

import { FieldState } from '../fields/fields.states';
import { FieldActions } from '../fields/fields.actions';
import {
  selectFields,
  selectCurSelectedFields,
} from '../fields/fields.selector';
import { MapActions } from '../map/map.actions';
import { AES, ECB, Hex, Pkcs7 } from 'crypto-es';

@Component({
    selector: 'app-field-details',
    templateUrl: './field-details.component.html',
    styleUrls: ['./field-details.component.scss'],
    standalone: false
})
export class FieldDetailsComponent implements OnChanges, OnDestroy {
  public fields$: Observable<Field[]>;
  public fieldsCurSelectedSub: Subscription;
  selectedField: Field | undefined;
  selectedScenario: Scenario | undefined;
  selectedEasyTramPlan: EasyTramPlan | undefined;

  public easyTramAccessible$: Observable<boolean>;
  public scenarioControlAccessible$: Observable<boolean>;

  formatDate = formatDate;

  constructor(
    public translate: TranslateService,
    private store: Store<{ auth: AuthState, fields: FieldState }>,
    private eventBus: EventBusService
  ) {
    this.scenarioControlAccessible$ = this.store.select('auth').pipe(select((authState) => {
      if (Array.isArray(authState.parsedAccessToken?.permissions)) {
        return authState.parsedAccessToken.permissions.includes('amaplan-scenario-control'); 
      } else {
        return authState.parsedAccessToken.permissions?.equals('amaplan-scenario-control');
      }
    }));
    
    this.easyTramAccessible$ = this.store.select('auth').pipe(select((authState) => {
      if (Array.isArray(authState.parsedAccessToken?.permissions)) {
        return authState.parsedAccessToken.permissions.includes('amaplan-easytram'); 
      } else {
        return authState.parsedAccessToken.permissions?.equals('amaplan-easytram');
      }
    }));

    this.fields$ = this.store.select('fields').pipe(select(selectFields));

    this.fieldsCurSelectedSub = this.store
      .select('fields')
      .pipe(select(selectCurSelectedFields))
      .subscribe((newSelectedFields: Field[]) => {
        if (
          newSelectedFields.length > 0 &&
          !newSelectedFields[0].equals(this.selectedField)
        ) {
          // current check for only one selected field at a time
          this.selectedField = newSelectedFields[0];

          console.log('selected field is now', this.selectedField);
        }
      });
  }

  ngOnChanges(): void {
    this.store
      .select('fields')
      .pipe(select(selectFields))
      .subscribe((fields) => {
        console.log('new fields is', fields);
      });
  }

  ngOnDestroy(): void {
    this.fieldsCurSelectedSub.unsubscribe();
  }

  deselectField(): void {
    if (this.selectedField?.id) {
      this.store.dispatch(
        FieldActions.selectField({ field: this.selectedField, select: false })
      );
    }
  }

  onActivateScenario(event: MatSlideToggleChange, scenario: Scenario): void {
    if (event.checked) {
      const newScenario = cloneScenario(scenario);
      newScenario.state = 'valid';
      this.store.dispatch(
        FieldActions.createOrUpdateScenario({
          field: this.selectedField!,
          scenario: newScenario,
        })
      );
    } else {
      event.source.checked = true;
    }
  }
  
  onActivateEasyTramPlan(event: MatSlideToggleChange, easyTramPlan: EasyTramPlan): void {
    if (event.checked) {
      const newEasyTramPlan = easyTramPlan.clone();
      this.store.dispatch(
        FieldActions.createOrUpdateEasyTramPlan({
          field: this.selectedField!,
          easyTramPlan: newEasyTramPlan,
        })
      );
    } else {
      event.source.checked = true;
    }
  }

  editField(): void {
    this.store.dispatch(
      MapActions.startEditField({ field: this.selectedField! })
    );
  }

  selectScenario(scenario) {
    if (this.selectedScenario == scenario) {
      this.selectedScenario = undefined;
    } else {
      this.selectedScenario = scenario;
    }
  }
  editScenario(): void {
    if (this.selectedScenario !== undefined) {
      this.store.dispatch(
        MapActions.startEditScenario({
          field: this.selectedField!,
          scenario: this.selectedScenario,
        })
      );
      // this.eventBus.publish({ name: 'edit scenario', data: this.selectedScenario.id });
    }
  }
  deleteScenario(): void {
    if (this.selectedScenario !== undefined) {
      this.store.dispatch(
        FieldActions.deleteScenario({
          field: this.selectedField!,
          scenario: this.selectedScenario,
        })
      );
      // this.eventBus.publish({ name: 'delete scenario', data: this.selectedScenario.id });
    }
  }

  selectEasyTramPlan(easyTramPlan) {
    if (this.selectedEasyTramPlan == easyTramPlan) {
      this.selectedEasyTramPlan = undefined;
    } else {
      this.selectedEasyTramPlan = easyTramPlan;
    }
  }
  editEasyTramPlan(): void {
    if (this.selectedEasyTramPlan !== undefined) {
      this.store.dispatch(
        MapActions.startEditEasyTramPlan({
          field: this.selectedField!,
          easyTramPlan: this.selectedEasyTramPlan,
        })
      );
    }
  }
  deleteEasyTramPlan(): void {
    if (this.selectedEasyTramPlan !== undefined) {
      // this.store.dispatch(
      //   FieldActions.deleteEasyTramPlan({
      //     field: this.selectedField!,
      //     easyTramPlan: this.selectedEasyTramPlan,
      //   })
      // );
    }
  }
  async exportEasyTramPlan(): Promise<void> {
    if (this.selectedEasyTramPlan !== undefined) {
      // this.store.dispatch(
      //   FieldActions.exportEasyTramPlan({
      //     field: this.selectedField!,
      //     easyTramPlan: this.selectedEasyTramPlan,
      //   })
      // );

      const planData = this.selectedEasyTramPlan.clone();
      const etramFileString = planData.toEtramFileContent(true);
      const etramFileBytes = new TextEncoder().encode(etramFileString);

      const link = document.createElement("a");
      link.download = planData.name + ".ETram";
      link.href = window.URL.createObjectURL(new Blob([etramFileBytes], { type: 'application/geo+json' }));
      link.dataset["downloadurl"] = ["application/geo+json", link.download, link.href].join(":");

      link.dispatchEvent(new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
      }));
      link.remove()
    }
  }
  async exportEasyTramPlanAsArchive(): Promise<void> {
    if (this.selectedEasyTramPlan !== undefined) {
      const planData = this.selectedEasyTramPlan.clone();
      const archive = await planData.toZipFileContent();

      const link = document.createElement("a");
      link.download = planData.name + ".zip";
      link.href = window.URL.createObjectURL(archive.to_blob());
      link.dataset["downloadurl"] = ["application/zip", link.download, link.href].join(":");

      link.dispatchEvent(new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
      }));
      link.remove()
    }
  }

}
